let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dq87X")).then(() => parcelRequire('e4Icc'));